export const ProtocolHeartStatusFilter = Object.freeze({
    ONLY_PROTOCOL_HEART: 'only_protocol_heart',
    ONLY_NON_PROTOCOL_HEART: 'only_non_protocol_heart',
});
